const reimburse = {
  plCode: '코드를 입력하세요',
  plName: '이름을 입력하세요',
  plDesc: '설명을 입력하세요',
  disableTip: '이 카테고리를 비활성화하시겠습니까',
  disableConfirm: '비활성화 확인',
  disableConfirmContent: '카테고리 비활성화 확인',
  disableSuccess: '비활성화 성공',
  disableSuccessDesc: '비활성화되었습니다',
  disableFailed: '비활성화 실패',
  disableFailedHasSubs: '이 카테고리에는 하위 카테고리가 있어 비활성화할 수 없습니다',
  addSuccessDesc: '추가되었습니다',
  updateSuccessDesc: '업데이트되었습니다',
  addFailed: '추가 실패',
  codeDuplicate: '코드가 이미 존재합니다',
  applicationTypeLabel: '신청 유형',
  approveTypeLabel: '승인 방식',
  stepCount: '단계',
  reimbursement: '지급 신청',
  dailySupplies: '일용품/자재 신청',
  materialOverIssue: '초과 자재 수령 신청',
  addMaterialOverIssue: '초과 자재 수령 신청 추가',
  materialOverIssueList: '초과 자재 수령 신청 목록',
  inOrder: '순서대로 승인',
  any: '임의 단계 승인',
  last: '최종 단계 승인',
  templateConfig: '템플릿 구성',
  approvalSteps: '승인 단계',
  step: '단계',
  addStep: '단계 추가',
  specificOrgAnyone: '지정된 조직의 아무나',
  applicantOrgAnyone: '신청자 조직의 아무나',
  specificUsers: '특정 사용자',
  plSelectOrg: '조직 ID를 입력하세요',
  plOrgId: '조직 ID',
  plSelectUsers: '사용자를 선택하세요',
  number: '번호',
  title: '제목',
  status: '상태',
  statusAll: '전체',
  statusDraft: '초안',
  statusPending: '승인 대기',
  statusApproved: '승인됨',
  statusRejected: '거부됨',
  statusReturned: '반송됨',
  applicationList: '신청 목록',
  addApplication: '추가',
  plTitle: '제목을 입력하세요',
  plContent: '내용을 입력하세요',
  plPurpose: '용도를 입력하세요',
  plRemark: '비고를 입력하세요',
  content: '내용',
  purpose: '용도',
  remark: '비고',
  items: '품목 상세',
  itemList: '신청 항목 리스트',
  count: '수량',
  selectProducts: '품번으로 추가',
  plSelectProducts: '물류를 선택하세요',
  submit: '제출',
  reSubmit: '재제출',
  submitSuccess: '제출 성공',
  submitFailed: '제출 실패',
  amount: '금액',
  orderAmount: '예정 수령 수량',
  productId: '품목 ID',
  requirementItemId: '요구사항 항목',
  overCount: '초과 수령 수량',
  reasonType: '초과 수령 사유',
  reasonMistake: '실수',
  reasonWaste: '낭비',
  reasonOther: '기타',
  reason: '상세 설명',
  picked: '출고 단 생성 여부',
  pickedYes: '예',
  pickedNo: '아니오',
  expenseDate: '비용 발생일',
  invoiceCount: '세금 계산서 수량',
  plAmount: '금액을 입력하세요',
  plInvoiceCount: '세금 계산서 수량을 입력하세요',
  plExpenseDate: '비용 발생일을 선택하세요',
  atLeastOne: '최소 하나 이상의 항목이 필요합니다',
  submitConfirm: '보상금을 제출하시겠습니까?',
  submitOverIssueConfirm: '초과 자재 수령 신청을 제출하시겠습니까?',
  addDailyItem: '품번호 없이 추가',
  approver: '승인자',
  actualApprover: '실제 승인자',
  approveTime: '승인 시간',
  approveOrg: '승인 조직',
  applicant: '신청자',
  submitTime: '제출 시간',
  completeTime: '완료 시간',
  stepNo: '단계',
  pass: '승인',
  reject: '거부',
  return: '반송',
  passSuccess: '승인됨',
  rejectSuccess: '거부됨',
  returnSuccess: '반송됨',
  passFailed: '승인 실패',
  rejectFailed: '거부 실패',
  returnFailed: '반송 실패',
  confirmPass: '승인하시겠습니까?',
  confirmReject: '거부하시겠습니까?',
  confirmReturn: '반송하시겠습니까?',
  approveRemark: '승인 비고',
  plApproveRemark: '승인 비고를 입력하세요',
  timeout: '타임아웃',
  approvalTimeLimit: '승인 시간 제한',
  enableConfirm: '활성화 확인',
  disableCascadeTip: '이 카테고리를 비활성화하면 하위 모든 카테고리도 비활성화됩니다',
  enableCascadeTip: '이 카테고리를 활성화하면 하위 모든 카테고리도 활성화됩니다',
};

export default reimburse;
